export default __webpack_public_path__ + "static/media/honeyHarvest.07bed80f.jpg";